export enum SELECTOR {
  LAYER = ".js_squirrel_searchSuggestionsContainer",
  SEARCH_CONTAINER = ".js_squirrel_searchContainer",
  SEARCH_WRAPPER = ".squirrel_searchbarWrapper",
  SEARCH_FORM = ".js_squirrel_searchForm",
  SEARCH_ICON = ".js_squirrel_searchIcon",
  HEADER_ELEMENT = ".js_find_header",
  SUGGEST_TERM = ".js_squirrel_searchSuggest",
  ABORT_BUTTON = ".js_squirrel_searchline__abort",
  CURTAIN = ".js_squirrel_searchCurtain",
  DELETE_BUTTON = ".js_squirrel_searchbar__delete",
  SUBMIT_BUTTON = ".js_squirrel_searchbar__submit",
  SEARCH_FIELD = ".js_squirrel_searchbar__input",
  SEARCH_TERM = ".js_squirrel_searchSuggest__term",
  MODIFIED_ARROW = ".js_squirrel_searchSuggest__arrow",
  SEARCHBAR = ".js_squirrel_searchbar",
  SELECTED_SEARCH_SUGGEST = ".squirrel_searchSuggest--selected",
  HISTORY = ".js_squirrel_searchHistory",
  HISTORY_CLASS = ".squirrel_searchHistory",
  HISTORY_TERM = ".js_squirrel_searchHistory__term",
  HISTORY_DELETEALL = ".js_squirrel_searchHistoryDelete",
  HISTORY_EDIT_BUTTON = ".js_squirrel_history_edit_button",
  HISTORY_ITEM_SELECT = ".js_squirrel_select_history_item",
  HISTORY_LAYER = ".js_squirrel_history_layer",

  /*             */
  SEARCH_SUGGEST = ".squirrel_searchSuggest",
  SUGGEST_ITEM = ".squirrel_searchSuggest__text",
  SUGGESTIONS_HEADLINE = ".squirrel_searchSuggestions__headline",
}

export const asClassName = (selector: SELECTOR): SELECTOR => {
  return selector.startsWith(".") ? (selector.substring(1) as SELECTOR) : selector;
};

export enum CLASSNAME {
  SEARCHBAR_WRAPPER_VISIBLE_SUGGESTIONS = "squirrel_searchbarWrapper--visibleSuggestions",
  SEARCHBAR_HEADER_VISIBILITY = "find_header--visibleSearchbar",
  SEARCHBAR_HEADER_ACTIVE = "find_header--activeSearch",
  SELECTED_SEARCH_SUGGEST = "squirrel_searchSuggest--selected",
  IGNORE_CLOSE_SUGGEST = "js_squirrel_ignore_close_suggest",
  HINT = "hint",
  SEARCHBAR_SHOW_BUTTONS = "squirrel_searchbar--showButtons",
  TRACK_MODIFIED = "san_track_modified",
  TRACK_SUGGEST = "san_track_suggest",

  SEARCH_FORM_CLASS = "js_squirrel_searchForm",
  SEARCH_CONTAINER_CLASS = "js_squirrel_searchContainer",
}

export enum REPTILE {
  SEARCH_RESULT_ID = "reptile-searchterm",
  SEARCH_RESULT_CLASS = "san_searchResult", /*          */
  SEARCH_RESULT_ERROR_NO_RESULTS_CLASS = "reptile_error__no-results",
}

export enum REPTILE_DATA {
  SEARCH_RESULT_QUERY = "data-searchterm",
}

export enum DATA {
  POS = "data-suggestpos",
  TERM = "data-term",
  TARGET_TERM = "data-target-term",
  TARGET = "data-target",
  ERROR = "data-error",
  SUGGEST_URL = "data-suggestserveruri",
  SUGGEST_SEARCH_TERM = "data-suggest-search-term",
  SUGGEST_WORD_LIST = "data-suggestWordList",
  SUGGEST_WORD_LIST_COUNT = "data-suggestWordListCount",
  ARTICLE_NUMBER_SEARCH = "data-article-number-search",
  HISTORY_INDEX = "data-historyIndex",
}

export enum KEY_CODE {
  ENTER = "13",
  ESC = "27",
  ARROW_UP = "38",
  ARROW_DOWN = "40",
  TAB = "9",
  BACKSPACE = "8",
}

export enum KEY {
  TAB = "Tab",
}
